import { render } from "./new-objective.vue?vue&type=template&id=3416092d&ts=true"
import script from "./new-objective.vue?vue&type=script&lang=ts"
export * from "./new-objective.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__